import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 2;
  background-color: #fff;
  max-height: 800px;
  min-width: 500px;
`;
